import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { PlanConfigurationUiService } from "./plan-configuration-ui.service";

export const PlanConfigurationGuard: CanActivateFn = () => {
  const planConfigurationUiService = inject(PlanConfigurationUiService);
  const router = inject(Router);

  if (planConfigurationUiService.hasPendingCustomSubscription()) {
    return router.parseUrl("/plan-configuration/checkout");
  }
  return true;
};
